import React, { useEffect } from 'react';
import { FormGroup, Label, Input, } from 'reactstrap';
import { omit, isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import { v4 as uuid, } from 'uuid';

import firebase, { functions, } from '../../firebase';
import { prefectures, } from '../../shared/config';
import { fields } from '../../shared/models/apiKey';
import { getAddressByPostalCode, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import Page from '../hocs/Page';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import SettingsTabs from '../SettingsTabs';

const { entries } = Object;
const db = firebase.firestore();

export default Page(function SettingsSenders (props) {
  const { tenant, user, } = props;
  const apiKeys = useCollectionSubscription(db.collection('apiKeys').where('tenantId', '==', tenant.id), [tenant.id]);

  return (
    <div className="settings-api-keys container-fluid">
      <div className="p-4 bg-white my-4">
        <SettingsTabs activeTab="apiKeys" />
        <div className="d-flex justify-content-start mb-3">
          <AddButton processValues={_ => ({ ..._, tenantId: tenant.id })} itemRef={_ => db.collection('apiKeys').doc(uuid())} FormModal={ModelFormModal} formProps={{ title: 'APIキー 追加', fields, }} />
        </div>
        <div className="mt-3 overflow-auto">
          {
            apiKeys.length > 0 ? (
              <table className="table sticky-table table-sm table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 200 }}>キー名</th>
                    <th style={{ minWidth: 200 }}>キー</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    apiKeys.map((apiKey) => {
                      const { id, ref, name, } = apiKey;

                      return (
                        <tr key={id}>
                          <td>
                            {name}
                          </td>
                          <td>
                            {id}
                          </td>
                          <td className="text-right text-nowrap">
                            <EditButton className="ml-2" itemRef={ref} FormModal={ModelFormModal} formProps={{ title: 'APIキー 編集', fields, }} />
                            <DeleteButton item={apiKey} itemRef={ref} className="ml-2" />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                APIキーは未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});

